export default {
  bp: {},
  colors: {
    primary: "#FFFFFF",
    secondary: "#000000",
  },
}
